import React, {useCallback, useContext, useState} from "react"
import Row from "@amzn/meridian/row";
import Table, {TableCell, TableRow,} from "@amzn/meridian/table"
import {RouteStageContext} from "../stageStatus/context/RouteStageContext";
import Pagination from "@amzn/meridian/pagination"
import {StageFilterContext} from "../stageStatus/context/StageFilterContext";
import Link from "@amzn/meridian/link";
import Tag from "@amzn/meridian/tag";
import Tooltip from "@amzn/meridian/tooltip";
import Input from "@amzn/meridian/input";
import {getDocumentURL} from "../handler/ParentDataHandler";
import CartContextMenu from "./CartContextMenu";
import {FormattedMessage} from "react-intl";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AR_V2, CORE_AMZL} from "../util/Constants";
import {convertMillisecondsToHHMM, naIfDefault} from "../util/Util";
import {getCartStatusColor} from "../util/EntityStatusManager";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const CartViewTable = (props) => {

    const { viewModel } = useContext(RouteStageContext)
    const { viewModelF } = useContext(StageFilterContext)
    const { configViewModel } = useContext(CapabilityContext)
    const {spacingInset_shorthand2} = useDeviceLayout()

    /** Pagination State **/
    const [currentPage, setCurrentPage] = useState(1)

    /** Sorting **/
    const [sortColumn, setSortColumn] = useState("Cart ID")
    const [sortDirection, setSortDirection] = useState("ascending")
    const onSort = useCallback(({ sortColumn, sortDirection }) => {
        setSortDirection(sortDirection)
        setSortColumn(sortColumn)
    }, [])

    /** In Line Table Filter **/
    const [cartIdFilter, setCartIdFilter] = useState("")
    const [routeCodeFilter, setRouteCodeFilter] = useState("")
    const [routeTypeFilter, setRouteTypeFilter] = useState("")
    const [status, setStatus] = useState("")
    const [routeSLA, setRouteSLA] = useState("");
    const [location, setLocation] = useState("");
    const [dwellDuration, setDwellDuration] = useState("");
    const [stageTime, setStageTime] = useState("");
    const [stageSLAFilter, setStageSLAFilter] = useState("");
    const [associateFilter, setAssociateFilter] = useState("");
    const [stationPairsFilter, setStationPairsFilter] = useState("");



    /** Filters **/
    const filterOption = (cart, filter, key) => {
        if (!viewModelF[filter] || viewModelF[filter].length === 0) {
            return true;
        }
        let result = false;
        viewModelF[filter].forEach(filterValue => {
            if (filter === 'status') {
                result = result || cart[key] === filterValue;
            } else if (cart[key].includes(filterValue)) {
                result = true;
            }
        })
        return result;
    }
    const inLineFilter = (cart, filter, key) => {
        return filter.length === 0 || (cart[key] != null && cart[key].toString().toLowerCase().startsWith(filter.toLowerCase()));
    }

    const inLineContainsFilter = (cart, filter, key) => {
        return filter.length === 0 || (cart[key] != null && cart[key].toString().toLowerCase().includes(filter.toLowerCase()));
    }

    let cartList = viewModel.cartList;
    cartList.sort((a, b) => {
        if (a[sortColumn] < b[sortColumn]) {
            return sortDirection === "ascending" ? -1 : 1
        }
        if (a[sortColumn] > b[sortColumn]) {
            return sortDirection === "ascending" ? 1 : -1
        }
        return 0
    })
    cartList = cartList
        .filter(cart => filterOption(cart, "cluster", "routeCode"))
        .filter(cart => filterOption(cart, "driverType", "routeType"))
        .filter(cart => filterOption(cart, "departure", "routeSLA"))
        .filter(cart => filterOption(cart, "status", "status"))
        .filter(cart => inLineFilter(cart, cartIdFilter, "cartId"))
        .filter(cart => inLineFilter(cart, routeCodeFilter, "routeCode"))
        .filter(cart => inLineContainsFilter(cart, routeTypeFilter, "routeType"))
        .filter(cart => inLineFilter(cart, status, "status"))
        .filter(cart => inLineFilter(cart, routeSLA, "routeSLA"))
        .filter(cart => inLineFilter(cart, location, "location"))
        .filter(cart => inLineFilter(cart, dwellDuration, "dwellingDuration"))
        .filter(cart => inLineFilter(cart, stageTime, "stageTime"))
        .filter(cart => inLineFilter(cart, stageSLAFilter, "stageSLA"))
        .filter(cart => inLineFilter(cart, associateFilter, "associate"))
        .filter(cart => inLineContainsFilter(cart, stationPairsFilter, "stationPairs"))        

    const itemOnPage = 50;
    const pageSize = Math.ceil(cartList.length / itemOnPage);
    const startPage = (currentPage  - 1) * itemOnPage;
    const endPage = (startPage + itemOnPage) > cartList.length - 1 ? cartList.length - 1 :
        (startPage + itemOnPage - 1);
    if (startPage > cartList.length) {
        setCurrentPage(1);
    }

    const onCartClick = (cart) => {
        const url = "/cartDetail/" + cart.routeId + "/" + cart.cartId + "/" + cart.status + "/" + cart.location
            + "/" + cart.associate + "/" + cart.stationCode;
        props.history.push(url)
    }

    const onRouteClick = (cart) => {
        getDocumentURL().then(result => {
            const params = [
                "Stage",
                naIfDefault(cart.routeId),
                naIfDefault(encodeURIComponent(cart.routeStatus)),
                naIfDefault(encodeURIComponent(cart.routeStagingLocation)),
                naIfDefault(cart.hazmatWeight),
                naIfDefault(cart.picker),
                naIfDefault(cart.routeCode),
                naIfDefault(cart.stationCode)
            ]
            const url = new URL(result.replace("stage", "pick"));
            const shareableLink = "/routeDetail/" + params.join("/");
            url.searchParams.set("shareableLink", shareableLink);
            window.open(url.href, "_parent")
        });
    }
    return (
        <div>
            <Row width="100%" widths="fill" spacingInset={spacingInset_shorthand2} className="enable-scroll-x">
                <div>
                    <div>
                        <Table
                            showStripes={configViewModel.capability === CORE_AMZL}
                            headerRows={1}
                            headerColumns={1}
                            fixHeaderRows={true}
                            stickyHeaderColumn={true}
                            stickyHeaderRow={true}
                            showDividers={configViewModel.capability === CORE_AMZL}
                            spacing={"small"}
                            sortColumn={sortColumn}
                            sortDirection={sortDirection}
                            onSort={onSort}>
                            <TableRow>
                                {configViewModel.capability === CORE_AMZL ?
                                    <TableCell alignmentHorizontal="right" sortColumn="routeSLA">
                                        <FormattedMessage id="stage.stageByTime" defaultMessage="Stage by time"/>
                                    </TableCell>
                                    : null
                                }
                                {configViewModel.capability === AR_V2 ?
                                    <TableCell alignmentHorizontal="right" sortColumn="stageSLA">
                                        <FormattedMessage id="routeStageTable.stageSLA" defaultMessage="Stage By Time" />
                                    </TableCell>
                                    : null
                                }
                                <TableCell sortColumn="routeCode">
                                    <FormattedMessage id="routeStageTable.routeId" defaultMessage="Route ID" />
                                </TableCell>
                                <TableCell sortColumn="cartId">
                                    <FormattedMessage id="routeStageTable.cartId" defaultMessage="Cart ID" />
                                </TableCell>
                                {configViewModel.capability === AR_V2 ?
                                    <TableCell sortColumn="stationPairs">
                                        <FormattedMessage id="routeStageTable.stationPairs" defaultMessage="Pick Station" />
                                    </TableCell>
                                    : null
                                }
                                <TableCell sortColumn="location">
                                    <FormattedMessage id="routeStageTable.cartView_location" defaultMessage="Staging Location" />
                                </TableCell>
                                <TableCell sortColumn="status">
                                    <FormattedMessage id="routeStageTable.status" defaultMessage="Status" />
                                </TableCell>
                                <TableCell alignmentHorizontal="right" sortColumn="dwellingDuration">
                                    <FormattedMessage id="routeStageTable.dwellDuration" defaultMessage="Dwell Duration" />
                                </TableCell>
                                {configViewModel.capability === CORE_AMZL ?
                                    <TableCell alignmentHorizontal="right" sortColumn="stageTime">
                                        <FormattedMessage id="routeStageTable.stageTime" defaultMessage="Stage Time"/>
                                    </TableCell>
                                    : null
                                }
                                <TableCell sortColumn="associate">
                                    <FormattedMessage id="cartInfo.associate" defaultMessage="Associate" />
                                </TableCell>
                                <TableCell sortColumn="routeType">
                                    <FormattedMessage id="routeStageTable.type" defaultMessage="Type" />
                                </TableCell>
                                <TableCell />
                            </TableRow>
                            <TableRow>
                                {configViewModel.capability === CORE_AMZL ?
                                    <TableCell>
                                        <Input type="text" size="small" value={routeSLA} onChange={setRouteSLA} />
                                    </TableCell>
                                    : null
                                }
                                {configViewModel.capability === AR_V2 ?
                                    <TableCell>
                                        <Input type="text" size="small" value={stageSLAFilter} onChange={setStageSLAFilter} />
                                    </TableCell>
                                    : null
                                }
                                <TableCell>
                                    <Input type="text" size="small" value={routeCodeFilter} onChange={setRouteCodeFilter} />
                                </TableCell>
                                <TableCell>
                                    <Input type="text" size="small" value={cartIdFilter} onChange={setCartIdFilter} />
                                </TableCell>
                                {configViewModel.capability === AR_V2 ?
                                    <TableCell>
                                        <Input type="text" size="small" value={stationPairsFilter} onChange={setStationPairsFilter} />
                                    </TableCell>
                                    : null
                                }
                                <TableCell>
                                    <Input type="text" size="small" value={location} onChange={setLocation} />
                                </TableCell>
                                <TableCell>
                                    <Input type="text" size="small" value={status} onChange={setStatus} />
                                </TableCell>
                                <TableCell>
                                    <Input type="text" size="small" value={dwellDuration} onChange={setDwellDuration} />
                                </TableCell>
                                {configViewModel.capability === CORE_AMZL ?
                                    <TableCell>
                                        <Input type="text" size="small" value={stageTime} onChange={setStageTime}/>
                                    </TableCell>
                                    : null
                                }
                                <TableCell>
                                    <Input type="text" size="small" value={associateFilter} onChange={setAssociateFilter} />
                                </TableCell>
                                <TableCell>
                                    <Input type="text" size="small" value={routeTypeFilter} onChange={setRouteTypeFilter} />
                                </TableCell>
                                <TableCell />
                            </TableRow>
                            {
                                cartList.map((cart, key) => (
                                    (key >= startPage && key <= endPage) ?
                                        <TableRow key={cart.routeCode+ cart.cartId}>
                                            {configViewModel.capability === CORE_AMZL ?
                                                <TableCell alignmentHorizontal="right">{cart.routeSLA}</TableCell>
                                                : null
                                            }
                                            {configViewModel.capability === AR_V2 ?
                                                <TableCell alignmentHorizontal="right">{cart.stageSLA}</TableCell>
                                                : null
                                            }
                                            <TableCell>
                                                <Link onClick={() => { onRouteClick(cart) }} type="secondary">{cart.routeCode}</Link>
                                            </TableCell>
                                            <TableCell width="145px">
                                                {configViewModel.capability === CORE_AMZL ?
                                                    <Link onClick={() => { onCartClick(cart) }} type="secondary">{cart.cartId}</Link>
                                                    : cart.cartId
                                                }
                                            </TableCell>
                                            {configViewModel.capability === AR_V2 ?
                                                <TableCell>{cart.floorLocation ?
                                                            cart.floorLocation : cart.stationPairs}</TableCell>
                                                            : null
                                            }
                                            <TableCell>{cart.location}</TableCell>
                                            <TableCell>
                                                <Tooltip position="top" title={cart.status}>
                                                    <Tag type={getCartStatusColor(cart.status)}>{cart.status && cart.status.length > 11 ?
                                                        cart.status.substr(0, 10) + "..." : cart.status}</Tag>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell alignmentHorizontal="right">{cart.dwellingDuration}</TableCell>
                                            {configViewModel.capability === CORE_AMZL ?
                                                <TableCell alignmentHorizontal="right">{convertMillisecondsToHHMM(cart.stageTime)}</TableCell>
                                                : null
                                            }
                                            <TableCell>{cart.associate}</TableCell>
                                            <TableCell>{cart.routeType}</TableCell>
                                            <TableCell>
                                                <CartContextMenu cart={cart} />
                                            </TableCell>
                                        </TableRow> :
                                        null
                                ))
                            }
                        </Table>
                    </div>
                    <div>
                        {cartList.length > 0 ?
                            <Row width="100%" alignmentHorizontal="center" spacingInset="medium none none">
                                <Pagination
                                    numberOfPages={pageSize}
                                    onChange={setCurrentPage}
                                    currentPage={currentPage} />
                            </Row> : null}
                    </div>
                </div>
            </Row>
        </div>
    )
}

export default CartViewTable


// WEBPACK FOOTER //
// ./src/components/routeStageStatus/CartViewTable.js